import NewsList from './NewsList.vue';

export { NewsList };
export default NewsList;
